import React, { useEffect, useState } from "react";
import { headChat } from "../../assets/image";
import CustomTable from "../../commons/CustomTable";
import Action from "../../commons/Action";
import { Badge } from "../../components/micro";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOnGoingServiceRequests } from "../../redux/serviceRequest/slice";
import moment from "moment";

const PastServices = () => {
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const getCompanyID = sessionStorage.getItem("companyID");

  // Selector
  const serviceSettingList = useSelector(
    (store) => store?.serviceRequestData?.getOnGoingServiceRequestsStatus?.data
  );
  const loading = useSelector((store) => store?.serviceRequestData?.loading);

  // Get On Going Service Requests API Call
  useEffect(() => {
    if (getCompanyID) {
      dispatch(
        getOnGoingServiceRequests({
          status: "completed",
          company_id: getCompanyID,
          pageCount: pageCount,
          pageLimit: pageLimit,
        })
      );
    }
  }, [dispatch, getCompanyID, pageCount, pageLimit]);

  // Table Heading
  const ColumnHeaders = () => {
    return (
      <>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          No.
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Request Type
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Price
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Request ID
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Date
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Status
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light "
        >
          Action
        </th>
      </>
    );
  };

  // Table Row
  const DataRows = () => {
    return (
      <>
        {(serviceSettingList?.data || [])?.map((element, index) => (
          <tr
            className={
              "border-b table_responsive_text hover:bg-secondary_light_shades"
            }
            key={element?.id}
          >
            <td className="px-5 py-3 truncate">{index + 1}</td>
            <td className="px-5 py-3 max-w-full truncate">
              {element?.service?.service_name}
            </td>
            <td className="px-5 py-3 truncate">
              {element?.service?.detail?.price > 0
                ? "$" + element?.service?.detail?.price
                : "Free"}
            </td>
            <td className="px-5 py-3 truncate">
              {element?.service_request_id}
            </td>
            <td className="px-5 py-3 truncate">
              {element?.created_at
                ? moment(element?.created_at).format("DD/MM/YYYY")
                : ""}
            </td>
            <td className="px-5 py-3 truncate">
              <div className="flex items-center">
                <Badge
                  value={element?.status}
                  className={`${
                    element?.status === "billing_needed"
                      ? "border-orange-600 bg-orange-600 text-white"
                      : element?.status === "expired"
                      ? "border-orange-600 text-orange-600"
                      : element?.status === "pending"
                      ? "border-theme text-theme"
                      : element?.status === "completed"
                      ? "border-success bg-success text-white"
                      : element?.status === "cancelled"
                      ? "border-red bg-red text-white"
                      : "border-theme text-theme"
                  } text-xs !px-2 capitalize !py-0.5`}
                />
              </div>
            </td>
            <td className="px-5 py-3">
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                      onClick={() =>
                        navigate("/service-request-details", {
                          state: element,
                        })
                      }
                    >
                      View
                    </li>
                  </>
                }
              />
            </td>
          </tr>
        ))}
      </>
    );
  };
  return (
    <div className="space-y-5">
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <p className="text-4xl font-ebGaramond">Your Past Services</p>
      </div>
      <p className="text-2xl font-ebGaramond">Past Request</p>
      <div className="border w-full rounded space-y-4 bg-white">
        <CustomTable
          columnHeaders={<ColumnHeaders />}
          dataRows={<DataRows />}
          data={serviceSettingList}
          overflowVisibleLg={true}
          // loader
          loading={loading}
          showPagination={true}
          // showLimit
          setPaginationCurrentLimit={setPageLimit}
          paginationCurrentLimit={pageLimit}
          // paginationData
          total={serviceSettingList?.total}
          current={pageCount}
          paginationData={(crPage) => setPageCount(crPage)}
        />
      </div>
    </div>
  );
};

export default PastServices;
